export const scheduleInformation = {
  id: "MENU_SCHEDULE_INFORMATION",
  icon: "InfoIcon",
  text: "Quản lý thông tin",
  child: [
    {
      id: "MENU_SCHEDULE_INFORMATION.SEMESTER",
      path: "/schedule-information/semester",
      isPublic: false,
      text: "Học kỳ",
      child: [],
    },
    {
      id: "MENU_SCHEDULE_INFORMATION.COURSE",
      path: "/schedule-information/course",
      isPublic: false,
      text: "Môn học",
      child: [],
    },
    {
      id: "MENU_SCHEDULE_INFORMATION.CLASSROOM",
      path: "/schedule-information/classroom",
      isPublic: false,
      text: "Phòng học",
      child: [],
    },
    {
      id: "MENU_SCHEDULE_INFORMATION.GROUP",
      path: "/schedule-information/group",
      isPublic: false,
      text: "Nhóm lớp",
      child: [],
    },
    {
      id: "MENU_SCHEDULE_INFORMATION.CLASS_PERIOD",
      path: "/schedule-information/class-period",
      isPublic: false,
      text: "Tiết học",
      child: [],
    },
    {
      id: "MENU_SCHEDULE_INFORMATION.WEEKDAY",
      path: "/schedule-information/week-day",
      isPublic: false,
      text: "Ngày trong tuần",
      child: [],
    },
    {
      id: "MENU_SCHEDULE_INFORMATION.ACADEMIC_WEEKS",
      path: "/schedule-information/academic-week",
      isPublic: false,
      text: "Danh sách tuần học",
      child: [],
    },
  ],
};
